"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddOnClick = exports.defaultOnClick = exports.stopFocusOnClick = void 0;
const react_1 = require("react");
const urlUtils_1 = require("../utils/urlUtils");
const stopFocusOnClick = (e) => {
    e.preventDefault();
};
exports.stopFocusOnClick = stopFocusOnClick;
function isNextLikeRouter(router) {
    // next/router should have BaseRouter.asPath and BaseRouter.basePath
    return router.asPath !== undefined && router.basePath !== undefined;
}
const defaultOnClick = ({ link, external, router, locale, customFn }) => {
    const { localeHref } = (0, urlUtils_1.getHrefWithLocale)(Object.assign(Object.assign({}, link), { locale }));
    if (link && link.useCustomCallback && localeHref) {
        link.onClick = (e) => {
            if (typeof customFn === "function") {
                const skip = customFn(e, localeHref);
                if (skip === true) {
                    return;
                }
            }
            //firefox middle clicks
            if (e.button && e.button > 0)
                return;
            //handle route
            e.preventDefault();
            e.stopPropagation();
            if (external) {
                (0, urlUtils_1.navigateWithHref)(localeHref, locale);
            }
            else if (isNextLikeRouter(router)) {
                router.push(link.href, undefined, { locale });
            }
            else {
                const finalHref = localeHref.replace(/\/$/, "");
                router.push(finalHref);
            }
        };
    }
    return link;
};
exports.defaultOnClick = defaultOnClick;
/**
 * Can be used to wrap basic on click functionality to links of the nav
 * @param router
 * @param locale Required to pass locale if used outside of the epic-games-nav-shared Localization Context
 * @returns
 */
const useAddOnClick = (router, locale) => {
    return (0, react_1.useCallback)((link, external, customFn) => {
        return (0, exports.defaultOnClick)({
            link,
            external,
            router,
            locale,
            customFn,
        });
    }, [router, locale]);
};
exports.useAddOnClick = useAddOnClick;
//# sourceMappingURL=onclick.hooks.js.map